var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("@/assets/images/404.jpg"),"width":"700"}}),_c('a',{attrs:{"href":"javascript:history.back()"}})])
}]

export { render, staticRenderFns }